module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 363
// module chunks = 0